import React, {useEffect, useState} from "react";


import SectionContainerComponent from "@Components/Sections/SectionContainer";
import {
    ButtonComponent, FormCheckboxComponent,
    FormComponent,
    FormContentComponent, FormDropdownComponent,
    FormSectionComponent, FormSubmitSectionComponent,
    InputComponent
} from "@Components/Forms";
import ConnectButtonComponent from "@Components/Forms/Buttons/ConnectButton";


import iconGoogle from "@Icons/SVG/icon-google-m.svg";
import iconMicrosoft from "@Icons/SVG/icon-microsoft-m.svg";
import iconStripe from "@Icons/SVG/icon-stripe-m.svg";
import iconPlaid from "@Icons/SVG/icon-plaid-m.svg";
import iconUpload from "@Icons/SVG/icon-file_upload-m-black.svg";
import {Col, Row} from "react-bootstrap";
import "./index.scss";


import {CountriesList} from "@Pages/JoinQyvo/RegisterForm/countries";
import {NavLink} from "react-router-dom";
import {InputComponentStatusType} from "@Components/Forms/Inputs/Input/types";
import isEmail from "validator/lib/isEmail";


export const JoinQyvoPageRegisterForm:React.FC = () => {


    const [firstName, setFirstName] = useState('');
    const [firstNameStatus, setFirstNameStatus] = useState<null | InputComponentStatusType>(null);
    const [lastName, setLastName] = useState('');
    const [lastNameStatus, setLastNameStatus] = useState<null | InputComponentStatusType>(null);
    const [primaryEmailAddress, setPrimaryEmailAddress] = useState('');
    const [primaryEmailAddressStatus, setPrimaryEmailAddressStatus] = useState<null | InputComponentStatusType>(null);
    const [secondaryEmailAddress, setSecondaryEmailAddress] = useState('');

    const [userPassword, setUserPassword] = useState('');
    const [userPasswordStatus, setUserPasswordStatus] = useState<null | InputComponentStatusType>(null);
    const [userPasswordConfirmation, setUserPasswordConfirmation] = useState('');
    const [userPasswordConfirmationStatus, setUserPasswordConfirmationStatus] = useState<null | InputComponentStatusType>(null);

    const [locationCountry, setLocationCountry] = useState(0);
    const [locationAddress, setLocationAddress] = useState('');
    const [locationPostalCode, setLocationPostalCode] = useState('');
    const [locationPhoneNumber, setLocationPhoneNumber] = useState('');

    const [regulationsCheckedStatus, setRegulationsCheckedStatus] = useState(false);

    const [registerFormSubmittedStatus, setRegisterFormSubmittedStatus] = useState(false);

    useEffect(() => {
        return () => {
            setFirstName('');
            setLastName('');
            setPrimaryEmailAddress('');
            setSecondaryEmailAddress('');
            setUserPassword('');
            setUserPasswordConfirmation('');
            setLocationCountry(0);
            setLocationAddress('');
            setLocationPostalCode('');
            setLocationPhoneNumber('');
            setRegulationsCheckedStatus(false);
            setRegisterFormSubmittedStatus(false);
        };
    }, []);

    const changeFirstName = (e:React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        if (value.length > 1 && firstNameStatus) {
            setFirstNameStatus({ type: 'success', message: '' });
        }
        setFirstName(value);
    };

    const changeLastName = (e:React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        if (value.length > 1 && lastNameStatus) {
            setLastNameStatus({ type: 'success', message: '' });
        }
        setLastName(value);
    };

    const changePrimaryEmailAddress = (e:React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        if (isEmail(value) && primaryEmailAddressStatus) {
            setPrimaryEmailAddressStatus({ type: 'success', message: '' });
        }
        setPrimaryEmailAddress(value);
    };

    const changeSecondaryEmailAddress  = (e:React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        setSecondaryEmailAddress(value);
    };

    const changeUserPassword  = (e:React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        if (value.length > 7 && userPasswordStatus) {
            setUserPasswordStatus({ type: 'success', message: '' });
        }
        setUserPassword(value);
    };

    const changeUserPasswordConfirmation  = (e:React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        if (value === userPassword) {
            setUserPasswordConfirmationStatus({ type: 'success', message: '' });
        }
        setUserPasswordConfirmation(value);
    };

    const changeLocationCountry = (countryID: number) => {
        setLocationCountry(countryID);
    };

    const changeLocationAddress = (e:React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        setLocationAddress(value);
    };

    const changeLocationPostalCode = (e:React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        setLocationPostalCode(value);
    };

    const changeLocationPhoneNumber = (e:React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        setLocationPhoneNumber(value);
    };

    const changeRegulationsCheckedStatus = () => {
        setRegulationsCheckedStatus(!regulationsCheckedStatus);
    };


    const countryOptions = CountriesList.map((item, i ) => {
        return { optionID: i + 1, optionValue: item.name };
    });

    const registerFormSubmitHandler = () => {

        let error = false;

        if (firstName.length < 2) {
            error = true;
            setFirstNameStatus({ type: 'error', message: 'Value is too short' });
        }

        if (lastName.length < 2) {
            error = true;
            setLastNameStatus({ type: 'error', message: 'Value is too short' });
        }

        if (!isEmail(primaryEmailAddress)) {
            error = true;
            setPrimaryEmailAddressStatus({ type: 'error', message: 'Email is not valid' });
        }

        if (userPassword.length < 8) {
            error = true;
            setUserPasswordStatus({ type: 'error', message: 'Password is too short' });
        }

        if (userPassword !== userPasswordConfirmation || userPasswordConfirmation === '') {
            error = true;
            setUserPasswordConfirmationStatus({ type: 'error', message: 'Passwords are not equal' });
        }

        if (error) {
            return;
        }

        qyvoUserRegisterRequestHandler();

    };

    const qyvoUserRegisterRequestHandler = async () => {

        const formData = new FormData();

        let userRegistrationAffiliate = localStorage.getItem('user_registration_affiliate');

        formData.append('user_email', primaryEmailAddress);
        formData.append('user_first_name', firstName);
        formData.append('user_last_name', lastName);
        formData.append('user_password', userPassword);
        formData.append('user_registration_affiliate', userRegistrationAffiliate ?? '0');

        try {
            const response = await fetch(
                'https://qyvo-engine.webpros.pl/api/v1/qyvo-users/register-user-email/',
                { method: 'POST', body: formData }
            );
            if (response.ok) {
                setRegisterFormSubmittedStatus(true);
                localStorage.removeItem('user_registration_affiliate');
            }
        } catch (e) {
            console.error(e);
        }

    };


    return (
        <SectionContainerComponent
            id={'join-qyvo-page__register-section'}
            sectionType={'main'}
        >

            {!registerFormSubmittedStatus &&
            <FormComponent xl={7}>

                <FormContentComponent>

                    <FormSectionComponent
                        sectionHeaderText={'Personal information'}
                    >

                        <InputComponent
                            value={firstName} setValue={(e) => changeFirstName(e)}
                            label={'First name'}
                            required={true} status={firstNameStatus}
                            xl={6} cssClasses={['register-form-first-name-field']}
                        />

                        <InputComponent
                            value={lastName} setValue={(e) => changeLastName(e)}
                            label={'Last name'}
                            required={true} status={lastNameStatus}
                            xl={6} cssClasses={['register-form-first-last-field']}
                        />

                        <InputComponent
                            value={primaryEmailAddress} setValue={(e) => changePrimaryEmailAddress(e)}
                            label={'Primary Email Address'}
                            legend={'Used for login and refund notifications'}
                            required={true} status={primaryEmailAddressStatus}
                        />

                        <InputComponent
                            value={secondaryEmailAddress} setValue={(e) => changeSecondaryEmailAddress(e)}
                            label={'Secondary Email (Optional)'}
                            legend={'Business or personal email for additional scanning'}
                            required={false} disabled={true}
                        />

                        <InputComponent
                            value={userPassword} setValue={(e) => changeUserPassword(e)}
                            type={'password'} label={'Password'}
                            required={true} status={userPasswordStatus}
                        />

	                    <InputComponent
		                    value={userPasswordConfirmation} setValue={(e) => changeUserPasswordConfirmation(e)}
		                    type={'password'} label={'Repeat Password'}
		                    required={true} status={userPasswordConfirmationStatus}
	                    />

                    </FormSectionComponent>

                    <FormSectionComponent
                        sectionHeaderText={'Connect your inbox'}
                    >

                        <Col xs={12} className={'form-connect-buttons-component'}>
                            <Row className={'form-connect-buttons-component__content'}>
                                <ConnectButtonComponent
                                    buttonText={'Connect Google'}
                                    buttonIcon={iconGoogle}
                                    buttonDisabled={true}
                                />
                                <ConnectButtonComponent
                                    buttonText={'Connect Microsoft'}
                                    buttonIcon={iconMicrosoft}
                                    buttonDisabled={true}
                                />
                            </Row>
                        </Col>

                        <Col xs={12} className={'form-section-extra-information-component'}>
                            <Row className={'form-section-extra-information-component__content'}>
                                <Col xs={12} className={'form-section-extra-information-component__title'}>
                                    <span>Can’t or won’t connect e-mail?</span>
                                </Col>
                                <Col xs={12} className={'form-section-extra-information-component__description'}>
                                    <span>Upload receipts instead and we'll scan them for refund opportunities.</span>
                                </Col>
                                <Col xs={12} className={'form-section-extra-information-component__buttons'}>
                                    <ButtonComponent
                                        text={'Upload documents'}
                                        size={'l'}
                                        iconLeft={iconUpload}
                                        buttonDisabled={true}
                                    />
                                </Col>
                            </Row>
                        </Col>

                    </FormSectionComponent>

                    <FormSectionComponent
                        sectionHeaderText={'Payment Information'}
                    >

                        <Col xs={12} className={'form-connect-buttons-component'}>
                            <Row className={'form-connect-buttons-component__content'}>
                                <ConnectButtonComponent
                                    buttonText={'Connect with Stripe'}
                                    buttonIcon={iconStripe}
                                    buttonDisabled={true}
                                />
                                <ConnectButtonComponent
                                    buttonText={'Connect with Plaid'}
                                    buttonIcon={iconPlaid}
                                    buttonDisabled={true}
                                />
                            </Row>
                            <Row className={'form-connect-buttons-component__legend'}>
                                <Col xs={12} className={'form-connect-buttons-component__legend__content'}>
                                    <span>Secure payment processing for receiving your refunds</span>
                                </Col>
                            </Row>
                        </Col>

                    </FormSectionComponent>

                    <FormSectionComponent
                        sectionHeaderText={'Location (optional)'}
                        sectionVisibility={{ visibilityStatus: true, visibilitySwitcher: true }}
                    >

                        <FormDropdownComponent
                            fieldOptions={countryOptions}
                            selectedOptionID={locationCountry}
                            optionChoiceHandler={changeLocationCountry}
                            fieldLabelText={'Select country'}
                            fieldRequiredStatus={true} fieldDisabledStatus={true}
                        />

                        <InputComponent
                            value={locationAddress} setValue={(e) => changeLocationAddress(e)}
                            disabled={true}
                            label={'Address'}
                            cssClasses={['register-form-location-address-field']}
                            xl={6}
                        />

                        <InputComponent
                            value={locationPostalCode} setValue={(e) => changeLocationPostalCode(e)}
                            disabled={true}
                            label={'Postal code'}
                            cssClasses={['register-form-location-postal-code-field']}
                            xl={6}
                        />

                        <InputComponent
                            value={locationPhoneNumber} setValue={(e) => changeLocationPhoneNumber(e)}
                            disabled={true}
                            label={'Phone number'}
                            cssClasses={['register-form-location-phone-number-field']}
                            xl={6}
                        />

                    </FormSectionComponent>

                    <FormSectionComponent>
                        <FormCheckboxComponent
                            labelText={`I have read and agree to Qyvo's <strong>Terms of Service</strong> and <strong>Privacy Policy</strong>.  I understand Qyvo charges a success fee only when refunds are obtained.`}
                            checkedStatus={regulationsCheckedStatus}
                            checkedStatusHandler={changeRegulationsCheckedStatus}
                            requiredStatus={true}
                        />
                    </FormSectionComponent>

                    <FormSubmitSectionComponent
                        buttonText={'Create My Qyvo Account'}
                        buttonCallback={() => registerFormSubmitHandler()}
                    >
                        <span>Already have an account?</span>
                        <NavLink to={'/sign-in'} title={'Sign in here'}>
                            <strong>Sign in here</strong>
                        </NavLink>
                    </FormSubmitSectionComponent>

                </FormContentComponent>

            </FormComponent>
        }

        {registerFormSubmittedStatus &&
        <Col xs={12} className={'communicate-element-component success-communicate'}>
            <span>Registered Successfully</span>
        </Col>
        }

        </SectionContainerComponent>
    );

};


export default JoinQyvoPageRegisterForm;
